let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("0feUU")).then(() => parcelRequire('3bGND'));